import { IMAGING_URL } from 'shared/api'
import getUploadWithEditsShared from 'creation/src/creation-tools/utils/get-upload-with-edits'
import { CreationToolSourceFile } from '../types'
import CreationToolOutputType from '../types/output-type'
import { SourceEditorEdits } from '../components/source-editor/types'

// Thin wrapper rather than a bare re-export: the shared function takes the
// imaging base url as an options argument instead of importing the
// Django-injected `IMAGING_URL` global directly (see the shared module for why).
const getUploadWithEdits = (
    source: CreationToolSourceFile,
    outputType: CreationToolOutputType,
    edits?: SourceEditorEdits
) => getUploadWithEditsShared(source, outputType, edits, { imagingUrl: IMAGING_URL })

export default getUploadWithEdits
